var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnxi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0843 15.3674H12.085C12.085 15.3674 12.0855 15.3674 12.0857 15.3674C13.8853 15.3671 15.344 13.9082 15.344 12.1085V10.2618C15.344 8.46196 13.8849 7.00293 12.0851 7.00293C10.2852 7.00293 8.82617 8.462 8.82617 10.2618V12.1085C8.82608 13.9082 10.2848 15.3671 12.0843 15.3674Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4163 15.3701C14.5689 16.2356 13.3883 16.7737 12.0841 16.7737C10.78 16.7737 9.5994 16.2356 8.75197 15.3701C7.51105 15.4304 6.52344 16.4555 6.52344 17.7114V23.9998H17.6448V17.7114C17.6449 16.4555 16.6572 15.4305 15.4163 15.3701Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.295 4.73208L12.5813 5.30097L13.6676 2.84482L12.2748 1.97616L12.8873 0.557496L11.596 0L10.5039 2.52943L11.8875 3.39228L11.295 4.73208Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1442 4.2287L19.6254 2.92139L17.0645 3.93778L17.4328 5.52626L16.0664 6.05468L16.5737 7.36649L19.0787 6.39783L18.7079 4.79876L20.1442 4.2287Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30058 6.66229L7.33191 4.15737L5.73284 4.52808L5.16278 3.0918L3.85547 3.61066L4.87177 6.17151L6.46034 5.80323L6.98877 7.16957L8.30058 6.66229Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnxi);
export default __webpack_public_path__ + "static/media/ANXI.967e3d6c6cb72db6d80ae558fc84c76a.svg";
export { ForwardRef as ReactComponent };